
import pmt from './pmt';



export function calculateRepayment(graduateIn: number, loanAmount: number, loanTerm: number, interestRate: number, payInterestDuringSchoolYear: boolean) {
  return -(pmt((interestRate / 100) / 12, loanTerm, loanAmount));
}

export function getRepaymentDetails(graduateIn: number, loanAmount: number, loanTerm: number, interestRate: number, payInterestDuringSchoolYear: boolean, payment: number) {
  let data: RepaymentDetail[] = [];

  let principal = loanAmount;
  for (let i = 0; i < loanTerm; i++) {
    if (principal <= 0) continue;
    let currentPrincipal = principal;
    let monthlyPayment = payment;
    if (currentPrincipal <= monthlyPayment) {
      monthlyPayment = currentPrincipal;
    }
    let currentInterestRate = (!payInterestDuringSchoolYear && (i < graduateIn)) ? 0 : (interestRate / 100);
    let interest = currentPrincipal * (currentInterestRate/12);
    let principalPayment = monthlyPayment - interest;
    principal = currentPrincipal - principalPayment;
    let endingBalance = principal;
    if (monthlyPayment < payment) {
      endingBalance = 0;
    }
    data.push({
      paymentNumber: i+1,
      beginningBalance: currentPrincipal,
      monthlyPayment: monthlyPayment,
      principalPayment: principalPayment,
      interestPayment: interest,
      endingBalance: endingBalance
    })
  }

  return data;
}

export function calculateTotalInterest(graduateIn: number, loanAmount: number, loanTerm: number, interestRate: number, payInterestDuringSchoolYear: boolean, payment: number) {
  let repaymentDetail = getRepaymentDetails(graduateIn, loanAmount, loanTerm , interestRate, payInterestDuringSchoolYear, payment)
  let totalInterest = 0;

  repaymentDetail.forEach(detail => {
    totalInterest += detail.interestPayment;
  });

  return totalInterest;
}

function solver(formula: (payment: number) => number, estimatedPayment: number, solverIncrement: number) {
  let lastEstimatedPayment = estimatedPayment;
  let lastResult: undefined|number = undefined;
  let result = estimatedPayment;
  let i = 0;
  while (i < 1000000) {
    let payment = lastEstimatedPayment + solverIncrement;
    result = formula(payment);
    // console.log(result, payment)
    if (lastResult !== undefined) {
      if (Math.abs(result) > Math.abs(lastResult)) break;
    }
    lastResult = result;
    lastEstimatedPayment = payment;
    i += 1;
  }

  return lastEstimatedPayment;
}


export function calculateRepaymentWithSolver(graduateIn: number, loanAmount: number, loanTerm: number, interestRate: number, payInterestDuringSchoolYear: boolean) {
  const calculateRemainingPrincipal = (payment: number) => {
    let principal = loanAmount;
    for (let i = 0; i < loanTerm; i++) {
      let currentPrincipal = principal;
      let currentInterestRate = (!payInterestDuringSchoolYear && (i < graduateIn)) ? 0 : (interestRate / 100);
      principal = (currentPrincipal * (1+currentInterestRate) ** (1/12)) - payment;
      // console.log('>>>', i, currentPrincipal, principal, currentInterestRate, payment)
    }
    return principal;
  };
  let repayment = solver(calculateRemainingPrincipal, 0, 1);
  repayment = solver(calculateRemainingPrincipal, repayment - 1, 0.01);

  return repayment;
}

export function calculateTotalInterestWithSolver(graduateIn: number, loanAmount: number, loanTerm: number, interestRate: number, payInterestDuringSchoolYear: boolean, payment: number) {
  let totalInterest = 0;

  let principal = loanAmount;
  for (let i = 0; i < loanTerm; i++) {
    let currentPrincipal = principal;
    let currentInterestRate = (!payInterestDuringSchoolYear && (i < graduateIn)) ? 0 : (interestRate / 100);
    principal = (currentPrincipal * (1+currentInterestRate) ** (1/12)) - payment;
    let interest = (currentPrincipal * (1+currentInterestRate) ** (1/12)) - currentPrincipal;
    totalInterest += interest;
    // console.log('>>>', i, currentPrincipal, principal, currentInterestRate, payment)
  }

  return totalInterest;
}
